import axios from 'axios';
import { API_BASE_URL } from './apiConfig';

/**
 * @param {object} params – from, to, userId, loginId, method, path, status, page, pageSize
 */
export async function fetchActivityLogs(params = {}) {
  try {
    const res = await axios.get(`${API_BASE_URL}/activity-log`, { params });
    if (!res.data.success) {
      throw new Error(res.data.message || 'Failed to load activity log');
    }
    return res.data;
  } catch (e) {
    if (axios.isAxiosError(e) && e.response?.status === 429) {
      throw new Error('Too many requests. Please wait a moment and try again.');
    }
    throw e;
  }
}
